import { Schema } from "effect";

// v3's `Schema.UUID` documented every id as the shared `UUID` component with `format: "uuid"`.
// v4's `isGUID` accepts the same strings but documents only a pattern, and `isUUID` would also
// reject ids that are not an RFC 9562 version, so the GUID check keeps v3's documentation here.
const UUID_PATTERN =
  "^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$";

export const UUID = Schema.String.check(
  Schema.isGUID({ toJsonSchema: () => ({ pattern: UUID_PATTERN, format: "uuid" }) })
).annotate({ identifier: "UUID", description: "a Universally Unique Identifier" });
